import React, { useMemo, useState } from 'react';
import { TRANSLATIONS_NAMESPACE_TPA } from '../../constants/translations';
import { TranslationContext } from '@wix/form-fields';
const Providers = ({ children, i18n, config }) => {
    const { locale = 'en', tpaTranslations } = config;
    useState(() => i18n.addResources(locale, TRANSLATIONS_NAMESPACE_TPA, tpaTranslations));
    const t = useMemo(() => i18n.getFixedT(locale, TRANSLATIONS_NAMESPACE_TPA), [locale, i18n]);
    return (React.createElement(TranslationContext.Provider, { value: { i18n, t } }, children));
};
export default Providers;
//# sourceMappingURL=providers.js.map